module.exports = __webpack_public_path__ + "static/media/dmv.f70b8afc.jpg";